import requests from "./httpService";

const OrderAndDealServices = {

    getOrderAndDeals: async () => {
        return requests.get(`/offers-deals`);
    },

    getCategoryActive: async () => {
        return requests.get(`/offers-deals/active`);
    },
    getOrderAndDealById: async (id) => {
        return requests.get(`/offers-deals/${id}`);
    },
    getSubCategoryByCategory: async (categoryId) => {
        return requests.get(`/offers-deals/${categoryId}`);
    },
    updateOrderAndDeals: async (id, body) => {
        return requests.patch(`/offers-deals/${id}`, body);
    },

    createOrderAndDeals: async (body) => {

        return requests.post(`/offers-deals`, body);
    },

    deleteOrderAndDeals: async (id) => {
        return requests.delete(`/offers-deals/${id}`);
    }



}
export default OrderAndDealServices;